// External libraries
import { Component } from "react";

// Kendo React components
import { Label } from "@progress/kendo-react-labels";

// Utilities
import { getIndexFromTemplate } from "../../Utilities/EntryUtils";

// Signals
import { template } from "../../Entry/Manage/EditEntrySignals";

export class IndexField extends Component {
  constructor({ field, value, handleFieldChange, templateId }) {
    super();
    const { fieldName, properties } = field;
    this.state = {
      value: value || "",
      fieldIndex: null,
      sectionIndex: null,
    };
    this.fieldName = fieldName;
    this.fontSize = properties?.fontSize || "12";
    this.fontWeight = properties?.fontWeight || "normal";
    this.padding =
      (properties?.paddingTop || 0) +
      "px " +
      (properties?.paddingRight || 0) +
      "px " +
      (properties?.paddingBottom || 0) +
      "px " +
      (properties?.paddingLeft || 0) +
      "px";
    this.prefix = properties?.Prefix || "";
    this.templateId = templateId;
    this.style = {
      fontSize: `${this.fontSize}px`,
      fontWeight: this.fontWeight,
      padding: this.padding,
      marginTop: "auto",
      marginBottom: "auto",
    };
    this.handleFieldChange = handleFieldChange;
    this.disposeDependencyEffect = () => {};
  }

  //#region lifecycle functions
  componentDidMount() {
    template.value.sections.forEach((section, sIndex) => {
      section.fields.forEach((field, fIndex) => {
        if (field.fieldName === this.fieldName) {
          this.setState({ fieldIndex: fIndex, sectionIndex: sIndex }, () => {
            if (this.state.value === "") {
              this.handleDependencyEffect({
                templateId: this.templateId,
                indexName: this.fieldName,
              });
            }
          });
        }
      });
    });
  }

  shouldComponentUpdate(_, nextState) {
    return (
      nextState.value !== this.state.value ||
      nextState.fieldIndex !== this.state.fieldIndex ||
      nextState.sectionIndex !== this.state.sectionIndex
    );
  }

  componentDidUpdate() {
    this.handleFieldChange({
      e: {
        target: {
          name: this.fieldName,
          value: this.state.value,
        },
        value: this.state.value,
      },
      sectionIndex: this.state.sectionIndex,
      fieldIndex: this.state.fieldIndex,
    });
  }

  componentWillUnmount() {
    this.disposeDependencyEffect();
  }
  //#endregion lifecycle functions

  //#region custom functions
  async handleDependencyEffect({ templateId, indexName }) {
    const indexValue = await getIndexFromTemplate({ templateId, indexName });
    this.setState({ value: this.prefix + indexValue });
  }
  //#endregion custom functions

  render() {
    return (
      <Label
        data-testid={this.fieldName}
        style={this.style}
        id={this.fieldName}
        name={this.fieldName}
      >
        {this.state.value}
      </Label>
    );
  }
}
